import { BASE_URL_ONLINE_DOCS } from '../../../base/constants/cgi-base';
// 拉取我的文件夹列表
export var FOLDER_LIST = "".concat(BASE_URL_ONLINE_DOCS, "folder_list");
// 创建文件夹
export var FOLDER_NEW = "".concat(BASE_URL_ONLINE_DOCS, "folder_new");
// 添加到我的文件夹
export var ADD_TO_MY_FOLDER = "".concat(BASE_URL_ONLINE_DOCS, "doc_addmy");
